import type { UnitModel } from '../../types';
import { initState, stepDynamic } from './dynamic';
import { solveSteady } from './steady';
import type {
  RectificationInputs,
  RectificationOutputs,
  RectificationParams,
  RectificationState,
} from './types';

/** Binar rektifikatsiya kolonnasi (McCabe-Thiele) — UnitModel. */
export const rectificationColumn: UnitModel<
  RectificationParams,
  RectificationInputs,
  RectificationState,
  RectificationOutputs,
  RectificationOutputs
> = {
  id: 'rectification-column',
  init: initState,
  step: stepDynamic,
  steady: solveSteady,
};

export * from './types';
export { solveSteady } from './steady';
export { MAX_STAGES, countStages } from './modes';
export { validateParams, validateInputs } from './validate';
export { initState, stepDynamic } from './dynamic';
export * from './vle';
export * from './mccabe-thiele';
export * from './energy';
export * from './hydraulics';
